import { createContext, useCallback, useState } from 'react';

import { ITour } from '../../pages/Map/hooks/useMapTour/useMapTour';
import { MapTourContextType } from './types';
import { TourType } from 'pages/Map/components/MapTour';

export const defaultMapTourContextType: MapTourContextType = {
    isMapTour: false,
    tour: undefined,
    setTour: ((_value: ITour | undefined) => {}) as any,
    setIsMapTour: () => {},
    isCurrentTourItem: (_type: string, _id?: string) => false
};

export const MapTourContext = createContext<MapTourContextType>(defaultMapTourContextType);

/**
 * MapTourContextProvider provides map tour context.
 */
export const MapTourContextProvider: React.FC = ({ children }) => {
    const [isMapTour, setIsMapTour] = useState(false);
    const [tour, setTour] = useState<ITour | undefined>();

    const isCurrentTourItem = useCallback(
        (type: string, id?: string) => {
            if (!isMapTour || !tour) {
                return false;
            }
            const { station, path } = tour;
            const isIdMatching = id ? [station?.id, path?.getId()].includes(id) : true;

            switch (type) {
                case TourType.ZOOM_IN_ZOOM_OUT:
                case TourType.INFO_ABOUT_STATIONS:
                case TourType.INFO_ABOUT_LEGENEDS:
                case TourType.INFO_ABOUT_PATHS:
                case TourType.TRANSITION_ZONE:
                case TourType.PLAN_UR_LIFE:
                    return type === tour.type;
                case TourType.STATION_AND_DRAWERS:
                    return type === tour.type && !!station && isIdMatching;
                default:
                    return false;
            }
        },
        [isMapTour, tour]
    );

    return (
        <MapTourContext.Provider value={{ isMapTour, tour, setTour, setIsMapTour, isCurrentTourItem }}>{children}</MapTourContext.Provider>
    );
};
